import { DataGridPremium } from '@mui/x-data-grid-premium';
import React, { FC } from 'react';

import { TableProps } from '../types';

export const Table: FC<TableProps> = ({
	rows,
	rowCount,
	columns,
	slotProps,
	slots,
	paginationModel,
	onPaginationModelChange,
	columnVisibilityModel,
	onSortModelChange,
	onFilterModelChange,
	sortingMode,
	filterMode,
	pagination,
	paginationMode,
	loading,
	hideFooter,
	hideFooterSelectedRowCount,
	onColumnVisibilityModelChange,
	onCellClick,
	style,
	initialState,
}) => (
	<div className='fullPageTable'>
		<DataGridPremium
			sx={style}
			rows={rows}
			rowCount={rowCount}
			columns={columns}
			slotProps={slotProps}
			slots={slots}
			paginationModel={paginationModel}
			onPaginationModelChange={onPaginationModelChange}
			columnVisibilityModel={columnVisibilityModel}
			onSortModelChange={onSortModelChange}
			onFilterModelChange={onFilterModelChange}
			sortingMode={sortingMode}
			filterMode={filterMode}
			pagination={pagination}
			paginationMode={paginationMode}
			loading={loading}
			hideFooter={hideFooter}
			hideFooterSelectedRowCount={hideFooterSelectedRowCount}
			onColumnVisibilityModelChange={onColumnVisibilityModelChange}
			onCellClick={onCellClick}
			initialState={initialState}
		/>
	</div>
);
